module.exports = __webpack_public_path__ + "static/media/15-8.f79b6f11.mp3";